import eventMessage from 'src/components/event-message';
import resourceXhr from 'src/components/resource-xhr';
import { PAGE_START_TIME, RESOURCE_TYPE } from 'src/constant';
import EVENT_MSG_TYPE from 'src/constant/event-msg-type';
import { safetyResUrl } from 'src/utils';
import { getResourceType } from 'src/utils/performance-resource';
import timingMath from 'src/utils/timing-math';

export default function resourceCollect() {
  try {
    const po = new PerformanceObserver((list) => {
      const t = Date.now();
      for (const entry of list.getEntries()) {
        const resourceEntry = entry as PerformanceResourceTiming;
        if(resourceEntry.initiatorType === 'beacon') {return;}

        const startTime = PAGE_START_TIME + resourceEntry.fetchStart;
        const { es, tnt, tcd, cacheType } = timingMath(resourceEntry);
        const rtiming = resourceEntry.toJSON();
        const resData: HBRequestInfo = {
          rtype: getResourceType(resourceEntry),
          res: resourceEntry.encodedBodySize,
          rurl: safetyResUrl(resourceEntry.name),
          tcd,
          rtiming,
        };
        rtiming.cacheType = cacheType;
        resData.es = es;
        if(resData.rtype !== RESOURCE_TYPE.XHR) {
          resData.tnt = tnt;
          eventMessage.publish<HBRequestInfo>({
            time: startTime || t,
            type: EVENT_MSG_TYPE.RESOURCE,
            data: resData,
          });
        } else {
          resourceXhr.push(resData);
        }
      }
    });
    po.observe({type: 'resource', buffered: true});
  } catch (err) {}
}
